import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DevolutionStoreState } from './states/devolution.store.state';
import { TransactionStoreState } from './states/transaction-store.state';

@NgModule({
  imports: [CommonModule],
  providers: [
    DevolutionStoreState,
    TransactionStoreState,
  ],
})

export class PixStoreModule { }
